import './user-profile-details-posts.scss';
import {useNavigate} from "react-router-dom";
import {OptionButton} from "../../../shared/option-button";
import React from "react";

type Props = {
    user: any;
}

const UserProfileDetailsPosts = ({user}) => {

    const navigate = useNavigate();

    return (
        <div>
            <div style={{marginBottom: '1rem', fontWeight: 'bold', fontSize: '1.2rem'}}>
                Work in progress: User Profile Posts
            </div>
            <div>
                De momento puedes acceder a:
                <div style={{
                    backgroundColor: 'rgba(129,129,129,0.05)',
                    padding: '1rem',
                    borderRadius: '16px',
                    marginTop: '0.5rem',
                }}>
                    <OptionButton
                        text="Colecciones"
                        onClick={() => navigate(`/user/${user.displayName}/${user.code}/collections`)}
                        icon={<i className="fa-solid fa-bookmark"></i>}/>
                    <OptionButton
                        text="Reseñas"
                        onClick={() => navigate(`/user/${user.displayName}/${user.code}/reviews`)}
                        icon={<i className="fa-solid fa-star"></i>}/>
                </div>
            </div>
        </div>
    )
};

export default UserProfileDetailsPosts;
